
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/_grading_box";
import "jst/_submission_detail";
import "jst/_avatar";
import "i18n!submission_details_dialog";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'SubmissionDetailsDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <button style=\"float: right;\" class=\"btn\" type=\"submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "update_grade", "Update Grade", options) : helperMissing.call(depth0, "t", "update_grade", "Update Grade", options)))
    + "</button>\n      ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <a class=\"more-details-link\" target=\"_blank\" href=\"";
  if (helper = helpers.speedGraderUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.speedGraderUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "more_details_in_the_speedgrader", "More details in the SpeedGrader", options) : helperMissing.call(depth0, "t", "more_details_in_the_speedgrader", "More details in the SpeedGrader", options)))
    + "</a>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <label for=\"submission_to_view\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "this_was_submitted_multiple_times_choose_a_submission_to_view", "Submitted multiple times, choose which to view:", options) : helperMissing.call(depth0, "t", "this_was_submitted_multiple_times_choose_a_submission_to_view", "Submitted multiple times, choose which to view:", options)))
    + "</label>\n          <select id=\"submission_to_view\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.submission_history), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </select>\n        ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <option>"
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.submitted_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.submitted_at), options)))
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.late), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</option>\n            ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "late", "LATE", options) : helperMissing.call(depth0, "t", "late", "LATE", options)))
    + " ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.submitted_at), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "submitted", "Submitted:", options) : helperMissing.call(depth0, "t", "submitted", "Submitted:", options)))
    + " "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.submitted_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.submitted_at), options)))
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.late), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</strong>\n          ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = self.invokePartial(partials.submission_detail, 'submission_detail', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"rubric-link\"><a class=\"rubric\" href=\"";
  if (helper = helpers.speedGraderUrl) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.speedGraderUrl); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "view_rubric_assessment_in_the_speedgrader", "View Rubric Assessment in the SpeedGrader", options) : helperMissing.call(depth0, "t", "view_rubric_assessment_in_the_speedgrader", "View Rubric Assessment in the SpeedGrader", options)))
    + "</a></div>\n      ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <h1>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "loading_comments", "Loading comments...", options) : helperMissing.call(depth0, "t", "loading_comments", "Loading comments...", options)))
    + "</h1>\n    ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.submission_comments), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <h1>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "comments", "Comments", options) : helperMissing.call(depth0, "t", "comments", "Comments", options)))
    + "</h1>\n        <div class=\"submission_details_comments\">\n          ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.submission_comments), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n      ";
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <article class=\"comment clearfix\">\n              "
    + escapeExpression((helper = helpers.friendlyDatetime || (depth0 && depth0.friendlyDatetime),options={hash:{
    'pubdate': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), options) : helperMissing.call(depth0, "friendlyDatetime", (depth0 && depth0.created_at), options)))
    + "\n              ";
  stack1 = self.invokePartial(partials.avatar, 'avatar', (depth0 && depth0.author), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              <div class=\"middle\">\n                <address class=\"vcard\">\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.anonymous), {hash:{},inverse:self.program(23, program23, data),fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                </address>\n                <div>\n                  "
    + escapeExpression((helper = helpers.newlinesToBreak || (depth0 && depth0.newlinesToBreak),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.comment), options) : helperMissing.call(depth0, "newlinesToBreak", (depth0 && depth0.comment), options)))
    + "\n                </div>\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.media_comment), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                <div class=\"comment_attachments\">\n                  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                </div>\n              </div>\n            </article>\n          ";
  return buffer;
  }
function program21(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                    ";
  if (helper = helpers.author_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.author_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                  ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                    <a class=\"fn url\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.html_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">";
  if (helper = helpers.author_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.author_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n                  ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <a data-media_comment_id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.media_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-media_comment_type=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.media_type)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"play_comment_link media-comment instructure_inline_media_comment\" >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "links.click_to_view", "click here to view", options) : helperMissing.call(depth0, "t", "links.click_to_view", "click here to view", options)))
    + "</a>\n                ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <div><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\""
    + escapeExpression((helper = helpers.mimeClass || (depth0 && depth0.mimeClass),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0['content-type']), options) : helperMissing.call(depth0, "mimeClass", (depth0 && depth0['content-type']), options)))
    + "\" title=\"";
  if (helper = helpers.filename) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.filename); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></div>\n                  ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <span id=\"group-comment-container\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.grade_group_students_individually), {hash:{},inverse:self.program(32, program32, data),fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </span>\n    ";
  return buffer;
  }
function program30(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <fieldset class=\"ic-Fieldset ic-Fieldset--radio-checkbox\">\n          <div class=\"ic-Form-control\" \"ic-Form-control--radio\">\n            <div class=\"ic-Radio\">\n              <input type=\"radio\" name=\"comment[group_comment]\" id=\"not_group_comment\" value=\"0\" checked>\n              <label for=\"not_group_comment\" class=\"ic-Label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "send_comment_to_this_student_only_e3d9ca1", "Send comment to this student only", options) : helperMissing.call(depth0, "t", "send_comment_to_this_student_only_e3d9ca1", "Send comment to this student only", options)))
    + "</label>\n            </div>\n            <div class=\"ic-Radio\">\n              <input type=\"radio\" name=\"comment[group_comment]\" id=\"group_comment\" value=\"1\">\n              <label for=\"group_comment\" class=\"ic-Label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "labels.group_comment", "Send comment to the whole group", options) : helperMissing.call(depth0, "t", "labels.group_comment", "Send comment to the whole group", options)))
    + "</label>\n            </div>\n          </div>\n        </fieldset>\n      ";
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <input type=\"checkbox\" style=\"display:none\" name=\"comment[group_comment]\" value=\"1\" checked />\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "all_comments_are_sent_to_the_whole_group_284591e7", "All comments are sent to the whole group", options) : helperMissing.call(depth0, "t", "all_comments_are_sent_to_the_whole_group_284591e7", "All comments are sent to the whole group", options)))
    + "\n      ";
  return buffer;
  }

  buffer += "<div class=\"submission_details_dialog\">\n  <h1 class=\"assignment-name\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</h1>\n  <section class=\"submission-details\">\n    <form class=\"submission_details_grade_form form-inline\">\n      <strong><label for=\"";
  if (helper = helpers.label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "grade_form_label", "Grade:", options) : helperMissing.call(depth0, "t", "grade_form_label", "Grade:", options)))
    + "</label></strong>\n      ";
  stack1 = self.invokePartial(partials.grading_box, 'grading_box', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </form>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.speedGraderUrl), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div>\n      <h2>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.moreThanOneSubmission), {hash:{},inverse:self.program(9, program9, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </h2>\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.submission_history), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.rubric_assessment), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </section>\n  <section>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.loading), {hash:{},inverse:self.program(18, program18, data),fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </section>\n  <form class=\"submission_details_add_comment_form clearfix\">\n    <label for=\"add_a_comment\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "add_a_comment", "Add a comment", options) : helperMissing.call(depth0, "t", "add_a_comment", "Add a comment", options)))
    + "</label>\n    <textarea id=\"add_a_comment\" name=\"comment[text_comment]\"></textarea>\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.group_category_id), {hash:{},inverse:self.noop,fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <button class=\"btn\" type=\"submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("submission_details_dialog")
  },data:data},helper ? helper.call(depth0, "post_comment", "Post Comment", options) : helperMissing.call(depth0, "t", "post_comment", "Post Comment", options)))
    + "</button>\n  </form>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/SubmissionDetailsDialog', {"new_styles_normal_contrast":{"combinedChecksum":"6568d86f15"},"new_styles_high_contrast":{"combinedChecksum":"6568d86f15"},"responsive_layout_normal_contrast":{"combinedChecksum":"6568d86f15"},"responsive_layout_high_contrast":{"combinedChecksum":"6568d86f15"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"8ebdf9cb6f"},"new_styles_high_contrast_rtl":{"combinedChecksum":"8ebdf9cb6f"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"8ebdf9cb6f"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"8ebdf9cb6f"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  